import SelectField from '@Fields/SelectField';
import TextField from '@Fields/TextField';
import LocationPickerField from '@Fields/LocationPickerField';
import { validateLocation } from '@Utilities/LocationValidator';

class ListingDetailCropForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = ListingDetailCropForm.modelToState(props);
        this.handleFieldChanged = this.handleFieldChanged.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.validatorCropDetails = this.validatorCropDetails.bind(this);
        this.UpdateSpecList = this.UpdateSpecList.bind(this);
        this.UpdateParentState = this.UpdateParentState.bind(this);
        this.SaveToXML = this.SaveToXML.bind(this);

        //updates the parent's validator to use this method
        var parentState = this.props.parentState;
        parentState.validatorCropDetails = this.validatorCropDetails;
        this.props.handleFormUpdate(parentState);
    }

    componentWillReceiveProps(Props) {
        this.setState({
            IsRegisteredUser: Props.parentState.IsRegisteredUser,
            EmailVerified: Props.parentState.ContactViewModel ? Props.parentState.ContactViewModel.EmailVerified : false
        });
    }

    static modelToState(props) {
        return {
            BaseCategory: 4,
            BaleTypeCatID: props.model.BaleTypeCatID,
            BaleList: props.model.BaleList,
            NumberOfBales: props.model.NumberOfBales,
            NumberOfTons: props.model.NumberOfTons,
            PricePerBale: props.model.PricePerBale,
            PricePerTon: props.model.PricePerTon,
            CurrencyCodeSelected: props.model.CurrencyCodeSelected,
            CurrencyCodeList: props.model.CurrencyCodeList,
            Description: props.model.Description,
            QueryString: props.parentState.QueryString,
            Translations: props.model.Translations,
            PriceDescription: props.model.PriceDescription,
            IsRegisteredUser: props.parentState.IsRegisteredUser,
            EmailVerified: props.parentState.ContactViewModel ? props.parentState.ContactViewModel.EmailVerified : false,
            HighlightErrors: {},
            FormErrors: [],
            InputErrors: {}
        };
    }

    handleFieldChanged(field, value) {
        var state = this.state;
        state[field] = value
        delete state.HighlightErrors[field];
        delete state.InputErrors[field];

        switch (field) {
            case "BaleTypeCatID":
                if ($(".toggle-details-2").is(":visible")) {
                    AdditionalDetailsToggle(true)
                }
                this.UpdateSpecList(state);
                this.UpdateParentState(state);
                this.SaveToXML(state);
                break;
            case "CurrencyCodeSelected":
                this.UpdateParentState(state);
                this.SaveToXML(state);
                break;
            default:
                break;
        }

        this.setState(state);
    }

    handleOnBlur(e, field) {
        var state = this.state;

        switch (field) {
            case "NumberOfBales":
                this.SaveToXML(state);
                break;
            case "NumberOfTons":
                this.SaveToXML(state);
                break;
            case "PricePerBale":
                this.SaveToXML(state);
                break; 
            case "PricePerTon":
                this.SaveToXML(state);
                break; 
            case "PriceDescription":
                this.SaveToXML(state);
                break;
            case "Description":
                this.SaveToXML(state);
                break;
            default:
                break;
        }

        this.UpdateParentState(state);
    }

    validatorCropDetails() {
        let state = this.state;
        let bHasErrors = false;
        let elementToScrollTo = {};
        let bIsFirstError = true;

        if (state.BaleTypeCatID == 0) {
            state.HighlightErrors.BaleTypeCatID = true;
            state.InputErrors.BaleTypeCatID = "Bale Type Is Required";
            bHasErrors = true;
            if (bIsFirstError) {
                bIsFirstError = false;
                elementToScrollTo = $('#BaleTypeCatID');
            }
        }

        var locationResult = validateLocation(this.props.parentState.ContactViewModel.LocationViewModel, state.Translations);
        if (locationResult.hasError) {
            state.HighlightErrors.LocationPicker = true;
            state.InputErrors.LocationPicker = locationResult.errorText;
            bHasErrors = true;
            if (bIsFirstError) {
                bIsFirstError = false;
                elementToScrollTo = $('#LocationPicker');
            }
        }
        else {
            delete state.HighlightErrors.LocationPicker;
            delete state.InputErrors.LocationPicker;
        }

        this.setState(state);

        if (bHasErrors) {
            ScrollToElement(elementToScrollTo);
        }

        return bHasErrors;
    }

    UpdateSpecList(state) {
        var objectToSend = {
            Category: state.BaleTypeCatID,
            QueryString: state.QueryString,
            FormInputs: this.props.parentState.SpecsViewModel.FormInputs
        }

        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var response = JSON.parse(xhr.response);

            var parentState = this.props.parentState;
            parentState.SpecsViewModel = response.oSpecsViewModel;
            parentState.SpecsViewModel.InputErrors = {};
            parentState.SpecsViewModel.HighlightErrors = {};
            this.props.handleFormUpdate(parentState);

        }.bind(this);

        xhr.open("POST", '/listinginput/specs/LoadSpecs', true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(JSON.stringify(objectToSend));
    }

    UpdateParentState(state) {

        var parentState = this.props.parentState;
        parentState.CropsViewModel.BaleTypeCatID = state.BaleTypeCatID;
        parentState.CropsViewModel.BaleList = state.BaleList;
        parentState.CropsViewModel.NumberOfBales = state.NumberOfBales;
        parentState.CropsViewModel.NumberOfTons = state.NumberOfTons;
        parentState.CropsViewModel.PricePerBale = state.PricePerBale;
        parentState.CropsViewModel.PricePerTon = state.PricePerTon;
        parentState.CropsViewModel.CurrencyCodeSelected = state.CurrencyCodeSelected;
        parentState.CropsViewModel.Description = state.Description;
        parentState.CropsViewModel.PriceDescription = state.PriceDescription;

        this.props.handleFormUpdate(parentState);
    }

    SaveToXML(state) {
        var objectToSend = {
            BaleTypeCatID: state.BaleTypeCatID,
            NumberOfBales: state.NumberOfBales,
            NumberOfTons: state.NumberOfTons,
            PricePerBale: state.PricePerBale,
            PricePerTon: state.PricePerTon,
            CurrencyCodeSelected: state.CurrencyCodeSelected,
            Description: state.Description,
            PriceDescription: state.PriceDescription
        }

        var xhr = new XMLHttpRequest();
        xhr.open("POST", '/listinginput/details/SaveCropDetails' + state.QueryString, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(JSON.stringify(objectToSend));
    }

    render() {
        var baleTypeddl = [];
        for (var i = 0; i < this.state.BaleList.length; i++) {
            baleTypeddl.push({ text: this.state.BaleList[i].Text, value: this.state.BaleList[i].Value });
        };

        let currencyddl = [];
        for (let i = 0; i < this.state.CurrencyCodeList.length; i++) {
            currencyddl.push({ text: this.state.CurrencyCodeList[i], value: this.state.CurrencyCodeList[i] });
        };

        return (
            <div>
                {/*Bale Type*/}
                <div className="form-row cf">
                    <label className="label-left" htmlFor="BaleTypeCatID">Bale Type <span>*</span></label>
                    <div className="input-right">
                        <SelectField
                            id="BaleTypeCatID"
                            value={this.state.BaleTypeCatID}
                            values={baleTypeddl}
                            onFieldChanged={(e) => { this.handleFieldChanged("BaleTypeCatID", e); }}
                            error={this.state.HighlightErrors.BaleTypeCatID}
                            errorText={this.state.InputErrors.BaleTypeCatID}
                            hasLabel={true}
                        />
                    </div>
                </div>

                {/*General Crop Description*/}
                <div className="form-row cf">
                    <label className="label-left" htmlFor="Description">{this.state.Translations["Description"]}</label>
                    <div className="input-right">
                        <TextField
                            id="Description"
                            type={"textarea"}
                            value={this.state.Description}
                            onFieldChanged={(e) => { this.handleFieldChanged("Description", e); }}
                            onBlur={(e) => { this.handleOnBlur(e, "Description"); }}
                            characterLimit={50000}
                            error={this.state.HighlightErrors.Description}
                            errorText={this.state.InputErrors.Description}
                            hasLabel={true}
                        />
                    </div>
                </div>

                {/*Location - City, State, Zip*/}
                <LocationPickerField
                    translations={this.state.Translations}
                    locationData={this.props.parentState.ContactViewModel.LocationViewModel}
                    onLocationChanged={(loc) => {
                        var highlightErrors = this.state.HighlightErrors;
                        var inputErrors = this.state.InputErrors;
                        delete highlightErrors.LocationPicker;
                        delete inputErrors.LocationPicker;
                        Object.assign(this.props.parentState.ContactViewModel.LocationViewModel, loc);
                        this.setState({ HighlightErrors: highlightErrors, InputErrors: inputErrors }, () => {
                            this.UpdateParentState(this.state);
                        });
                    }}
                    onValidation={(result) => {
                        var highlightErrors = this.state.HighlightErrors;
                        var inputErrors = this.state.InputErrors;
                        if (result.hasError) {
                            highlightErrors.LocationPicker = true;
                            inputErrors.LocationPicker = result.errorText;
                        } else {
                            delete highlightErrors.LocationPicker;
                            delete inputErrors.LocationPicker;
                        }
                        this.setState({ HighlightErrors: highlightErrors, InputErrors: inputErrors });
                    }}
                    onBlur={() => { this.UpdateParentState(this.state); }}
                    highlightErrors={this.state.HighlightErrors}
                    inputErrors={this.state.InputErrors}
                    showWeeklyUpdateSubscriptionCheckbox={this.props.parentState.ContactViewModel.ShowWeeklyUpdateSubscriptionCheckbox}
                    onReceiveEmailsChanged={(val) => { this.props.parentState.ContactViewModel.ReceiveEmails = val; this.UpdateParentState(this.state); }}
                />

                {/*Header for Price Info*/}
                <div className="additional-details" onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { PriceOptionsToggle(e); } }} onClick={(e) => { PriceOptionsToggle(e) }} tabIndex="0">
                    <div className="price-options" style={{ display: 'none' }}>
                        <strong>Pricing Information Details <i className="fa fa-plus" aria-hidden="true"></i></strong>
                    </div>
                    <div className="price-options-2">
                        <strong>Close Pricing Information Details <i className="fa fa-minus" aria-hidden="true"></i></strong>
                    </div>
                </div>

                {/*Content to be toggled*/}
                <div className="price-content" style={{ display: 'block' }}>
                    <div className="accordion cf" id="priceDetails-content-0" style={{ display: 'block' }}>
                        <div className="validationError">
                            <span>{this.state.FormErrors}</span>
                        </div>

                        <div className="column6 left accordian-skip">
                            <TextField
                                type='number'
                                min="0"
                                NumbersOnly={true}
                                id="NumberOfBales"
                                value={this.state.NumberOfBales == 0 ? "" : this.state.NumberOfBales.toString()}
                                onFieldChanged={(e) => { this.handleFieldChanged("NumberOfBales", e); }}
                                onBlur={(e) => { this.handleOnBlur(e, "NumberOfBales"); }}
                                error={this.state.HighlightErrors.NumberOfBales}
                                errorText={this.state.InputErrors.NumberOfBales}
                                label="Number of Bales"
                            />
                        </div>
                        <div className="column6 left accordian-skip">
                            <TextField
                                type='number'
                                min="0"
                                NumbersOnly={true}
                                id="NumberOfTons"
                                value={this.state.NumberOfTons == 0 ? "" : this.state.NumberOfTons.toString()}
                                onFieldChanged={(e) => { this.handleFieldChanged("NumberOfTons", e); }}
                                onBlur={(e) => { this.handleOnBlur(e, "NumberOfTons"); }}
                                error={this.state.HighlightErrors.NumberOfTons}
                                errorText={this.state.InputErrors.NumberOfTons}
                                label="Total Weight (Tons)"
                            />
                        </div>
                        <div className="column4 left accordian-skip">
                            <TextField
                                type='number'
                                min="0"
                                AddCommas={true}
                                NumbersOnly={true}
                                id="PricePerBale"
                                value={this.state.PricePerBale == 0 ? "" : this.state.PricePerBale.toString()}
                                onFieldChanged={(e) => { this.handleFieldChanged("PricePerBale", e); }}
                                onBlur={(e) => { this.handleOnBlur(e, "PricePerBale"); }}
                                error={this.state.HighlightErrors.PricePerBale}
                                errorText={this.state.InputErrors.PricePerBale}
                                label="Price (Per Bale)"
                            />
                        </div>
                        <div className="column4 left accordian-skip">
                            <TextField
                                type='number'
                                min="0"
                                AddCommas={true}
                                id="PricePerTon"
                                NumbersOnly={true}
                                value={this.state.PricePerTon == 0 ? "" : this.state.PricePerTon.toString()}
                                onFieldChanged={(e) => { this.handleFieldChanged("PricePerTon", e); }}
                                onBlur={(e) => { this.handleOnBlur(e, "PricePerTon"); }}
                                error={this.state.HighlightErrors.PricePerTon}
                                errorText={this.state.InputErrors.PricePerTon}
                                label="Price (Per Ton)"
                            />
                        </div>
                        <div className="column4 left accordian-skip" style={{ height: '70px', display: 'flex' }}>
                            <SelectField
                                id="CurrencyCodeSelected"
                                value={this.state.CurrencyCodeSelected}
                                values={currencyddl}
                                onFieldChanged={(e) => { this.handleFieldChanged("CurrencyCodeSelected", e); }}
                                error={this.state.HighlightErrors.CurrencyCodeSelected}
                                errorText={this.state.InputErrors.CurrencyCodeSelected}
                                hasLabel={true}
                                alignBottom={true}
                                ariaLabelledBy={"PricePerTonlabel"}
                            />
                        </div>
                        <div className="column12 left">
                            <TextField
                                id="PriceDescription"
                                type={"textarea"}
                                label="Price Description"
                                value={this.state.PriceDescription}
                                onFieldChanged={(e) => { this.handleFieldChanged("PriceDescription", e); }}
                                onBlur={(e) => { this.handleOnBlur(e, "PriceDescription"); }}
                                characterLimit={50000}
                                error={this.state.HighlightErrors.PriceDescription}
                                errorText={this.state.InputErrors.PriceDescription}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ListingDetailCropForm;
global.ListingDetailCropForm = ListingDetailCropForm;